import { buildValidations, validator } from 'ember-cp-validations';
import Model, { attr } from '@ember-data/model';
import classic from 'ember-classic-decorator';

const Validations = buildValidations({
  email: [
    validator('presence', {
      presence: true,
      ignoreBlank: false,
      messageKey: 'errors.signInToken.email',
    }),
    validator('format', {
      type: 'email',
      messageKey: 'errors.signInToken.email',
    }),
  ],
});

@classic
export default class SignInTokenModel extends Model.extend(Validations) {
  @attr() email;
  @attr() expiresIn;
  @attr() redirect;
}
